(() => {
  const selector = 'details[data-zyvoria-product-details-default-open]';
  const initializedAttribute = 'data-zyvoria-default-open-initialized';

  function initialize(root = document) {
    const details = [];

    if (root.matches?.(selector)) details.push(root);
    details.push(...root.querySelectorAll?.(selector) || []);

    details.forEach((item) => {
      if (item.hasAttribute(initializedAttribute)) return;

      item.setAttribute(initializedAttribute, 'true');
      item.open = true;

      const body = item.querySelector('[data-collapsible-body]');
      if (body) body.style.height = 'auto';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
  } else {
    initialize();
  }

  document.addEventListener('theme:product-info:loaded', (event) => initialize(event.target));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
